(() => {
// The preorder app can inject its full pre-order message into collection-card forms after load.
  // Cards already have our Pre Order badge/button, so suppress only that duplicated long message.
  const hideInjectedCardPreorderMessages = rootNode => {
    const cards = new Set();

    if (rootNode === document) {
      document.querySelectorAll('.product-card').forEach(card => cards.add(card));
    } else if (rootNode?.nodeType === Node.ELEMENT_NODE) {
      if (rootNode.matches('.product-card')) cards.add(rootNode);
      const closestCard = rootNode.closest?.('.product-card');
      if (closestCard) cards.add(closestCard);
      rootNode.querySelectorAll?.('.product-card').forEach(card => cards.add(card));
    }

    cards.forEach(card => {
      card.querySelectorAll('p, div, aside, section, span').forEach(el => {
        if (el.matches('.prh-preorder-overlay,.mini-badge,.card-add-button,.product-card__bottom,.product-meta') ||
            el.closest('.card-add-button,.product-card__bottom,.product-meta,.badge-row')) return;
        const directText = Array.from(el.childNodes)
          .filter(node => node.nodeType === Node.TEXT_NODE || node.nodeName === 'STRONG' || node.nodeName === 'B')
          .map(node => (node.textContent || '').replace(/\s+/g,' ').trim())
          .join(' ')
          .toLowerCase();
        if (
          directText.includes('pre-order item') &&
          (directText.includes('expected release') || directText.includes('ships after release'))
        ) {
          el.style.setProperty('display','none','important');
        }
      });
    });
  };

  hideInjectedCardPreorderMessages(document);

  const preorderCardObserverRoot = document.querySelector('#MainContent') || document.body;
  if (preorderCardObserverRoot) {
    new MutationObserver(mutations => {
      const addedRoots = new Set();

      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === Node.ELEMENT_NODE) addedRoots.add(node);
          else if (node.parentElement) addedRoots.add(node.parentElement);
        });
      });

      addedRoots.forEach(root => hideInjectedCardPreorderMessages(root));
    }).observe(preorderCardObserverRoot,{childList:true,subtree:true});
  }
})();

(() => {
// Publisher comic pages: sort alphabetically by series, then numerically by issue.
  // If Game Cart metafields exist, they are preferred. Otherwise, derive both from the title.
  document.querySelectorAll('[data-publisher-series-list]').forEach(list => {
    const sourceGrid = list.querySelector('[data-publisher-sort-grid]');
    if (!sourceGrid) return;

    const cards = Array.from(sourceGrid.querySelectorAll(':scope > .product-card'));
    if (!cards.length) return;

    const parseCard = card => {
      const title = (card.dataset.productTitle || '').trim();
      let series = (card.dataset.series || '').trim();
      const explicitIssue = (card.dataset.issue || '').trim();

      let issue = Number.POSITIVE_INFINITY;
      let issueSuffix = '';

      if (explicitIssue) {
        const explicitMatch = explicitIssue.match(/(\d+(?:\.\d+)?)([a-z]*)/i);
        if (explicitMatch) {
          issue = Number.parseFloat(explicitMatch[1]);
          issueSuffix = (explicitMatch[2] || '').toLowerCase();
        }
      }

      // Typical comic title format: Series Name #12 Variant...
      const titleMatch = title.match(/^(.*?)\s+#\s*(\d+(?:\.\d+)?)([a-z]*)\b/i);
      if (titleMatch) {
        if (!series) series = titleMatch[1].trim();
        if (!Number.isFinite(issue)) {
          issue = Number.parseFloat(titleMatch[2]);
          issueSuffix = (titleMatch[3] || '').toLowerCase();
        }
      }

      // Also recognize "No. 12" if a title uses that convention.
      if (!series) {
        const noMatch = title.match(/^(.*?)\s+(?:no\.?|issue)\s*(\d+(?:\.\d+)?)([a-z]*)\b/i);
        if (noMatch) {
          series = noMatch[1].trim();
          if (!Number.isFinite(issue)) {
            issue = Number.parseFloat(noMatch[2]);
            issueSuffix = (noMatch[3] || '').toLowerCase();
          }
        }
      }

      if (!series) series = title;

      return {
        card,
        title,
        series: series.replace(/\s+/g, ' ').trim(),
        seriesKey: series.replace(/\s+/g, ' ').trim().toLocaleLowerCase(),
        issue,
        issueSuffix
      };
    };

    const parsed = cards.map(parseCard);
    parsed.sort((a, b) => {
      const seriesCompare = a.series.localeCompare(b.series, undefined, { numeric: true, sensitivity: 'base' });
      if (seriesCompare) return seriesCompare;

      if (a.issue !== b.issue) {
        if (!Number.isFinite(a.issue)) return 1;
        if (!Number.isFinite(b.issue)) return -1;
        return a.issue - b.issue;
      }

      const suffixCompare = a.issueSuffix.localeCompare(b.issueSuffix, undefined, { sensitivity: 'base' });
      if (suffixCompare) return suffixCompare;

      return a.title.localeCompare(b.title, undefined, { numeric: true, sensitivity: 'base' });
    });

    sourceGrid.remove();

    let currentKey = null;
    let currentGrid = null;
    let currentCount = null;

    parsed.forEach(item => {
      if (item.seriesKey !== currentKey) {
        currentKey = item.seriesKey;

        const group = document.createElement('section');
        group.className = 'publisher-series-group';

        const heading = document.createElement('div');
        heading.className = 'publisher-series-heading';

        const titleEl = document.createElement('h2');
        titleEl.textContent = item.series;

        currentCount = document.createElement('span');

        heading.append(titleEl, currentCount);

        currentGrid = document.createElement('div');
        currentGrid.className = 'product-grid publisher-series-grid';

        group.append(heading, currentGrid);
        list.appendChild(group);
      }

      currentGrid.appendChild(item.card);

      const count = currentGrid.children.length;
      currentCount.textContent = `${count} ${count === 1 ? 'issue' : 'issues'}`;
    });
  });
})();
/* GAMECART SERIES NAVIGATION V1 */
(() => {
  const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

  const normalizeSeries = raw => {
    let value = (raw || '').trim();
    value = value.replace(/^the\s+/i, '').trim();
    return value;
  };

  const seriesForCard = card => {
    const direct = normalizeSeries(card.dataset.series);
    if (direct) return direct;
    const title = (card.dataset.productTitle || '').trim();
    return normalizeSeries((title.split('#')[0] || title).trim()) || 'Other Titles';
  };

  const issueValue = card => {
    const direct = (card.dataset.issue || '').trim();
    if (direct) return direct;
    const title = card.dataset.productTitle || '';
    const match = title.match(/#\s*([0-9]+(?:\.[0-9]+)?[A-Za-z]?)/);
    return match ? match[1] : '';
  };

  const compareIssueMeta = (a, b) => {
    const av = a?.issue || '';
    const bv = b?.issue || '';
    const an = a?.issueNumber;
    const bn = b?.issueNumber;
    const aNumeric = Boolean(a?.issueNumeric);
    const bNumeric = Boolean(b?.issueNumeric);

    if (aNumeric && bNumeric && an !== bn) return an - bn;
    if (aNumeric && !bNumeric) return -1;
    if (!aNumeric && bNumeric) return 1;
    return collator.compare(av || 'zzzz', bv || 'zzzz');
  };

  const buildIssueGroups = (cards, cardMeta) => {
    const wrap = document.createElement('div');
    wrap.className = 'series-issues';

    const issueRecords = [];
    const sortedCards = cards.slice().sort((a, b) => compareIssueMeta(cardMeta.get(a), cardMeta.get(b)));

    let currentKey = null;
    let currentGrid = null;
    let currentCount = 0;
    let currentCountLabel = null;
    let currentRecord = null;

    const finishCount = () => {
      if (!currentCountLabel) return;
      currentCountLabel.textContent = currentCount === 1 ? '1 cover' : String(currentCount) + ' covers';
    };

    sortedCards.forEach(card => {
      const meta = cardMeta.get(card);
      const rawIssue = meta?.issue || '';
      const issueKey = rawIssue || 'other';

      if (issueKey !== currentKey) {
        finishCount();
        currentKey = issueKey;
        currentCount = 0;

        const issueSection = document.createElement('section');
        issueSection.className = 'series-issue-group';
        issueSection.dataset.issue = issueKey;

        const heading = document.createElement('div');
        heading.className = 'series-issue-heading';

        const title = document.createElement('h3');
        title.textContent = rawIssue ? 'Issue #' + rawIssue : 'Other Titles';

        currentCountLabel = document.createElement('span');
        heading.append(title, currentCountLabel);

        currentGrid = document.createElement('div');
        currentGrid.className = 'product-grid publisher-series-grid series-issue-grid';

        issueSection.append(heading, currentGrid);
        wrap.appendChild(issueSection);

        currentRecord = {
          element: issueSection,
          cards: [],
          countLabel: currentCountLabel
        };
        issueRecords.push(currentRecord);
      }

      currentCount += 1;
      currentRecord?.cards.push(card);
      currentGrid.appendChild(card);
    });

    finishCount();
    return { element: wrap, records: issueRecords };
  };

  const seriesSlug = value => value
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '') || 'other-titles';

  const seriesInitial = value => {
    const normalized = String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').trim();
    const first = normalized.charAt(0).toUpperCase();
    return /^[A-Z]$/.test(first) ? first : '#';
  };

  const availabilityLabels = {
    'in-stock': 'In Stock',
    'preorder': 'Pre Order',
    'coming-soon': 'Coming Soon',
    'sold-out': 'Sold Out'
  };

  const availabilityOrder = ['in-stock', 'preorder', 'coming-soon', 'sold-out'];

  /* GAMECART PUBLISHER PAYLOAD PHASE 4 2026 10 01 */
  const parsePublisherBatch = html => {
    const template = document.createElement('template');
    template.innerHTML = String(html || '').trim();
    const batch = template.content.querySelector('[data-series-batch]');
    if (!batch) throw new Error('Publisher batch response did not contain product cards.');

    return Array.from(batch.children).filter(element => element.classList.contains('product-card'));
  };

  const fetchPublisherBatch = async page => {
    const url = new URL(window.location.href);
    url.hash = '';
    url.searchParams.set('view', 'publisher-batch');
    url.searchParams.set('page', String(page));

    const response = await fetch(url.toString(), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    if (!response.ok) throw new Error('Publisher batch request failed with status ' + response.status);
    return parsePublisherBatch(await response.text());
  };

  const hydratePublisherCards = async (browser, cards) => {
    const shells = cards.filter(card => card.classList.contains('publisher-card-shell'));
    const totalPages = Number.parseInt(browser.dataset.seriesTotalPages || '1', 10);

    if (!shells.length || !Number.isFinite(totalPages) || totalPages <= 1) return;

    const shellByProductId = new Map(
      shells
        .map(shell => [shell.dataset.productId || '', shell])
        .filter(([productId]) => productId)
    );

    const hydrateShell = fullCard => {
      const productId = fullCard.dataset.productId || '';
      const shell = shellByProductId.get(productId);
      if (!shell) return;

      const wasHidden = shell.hidden;

      Array.from(shell.attributes).forEach(attribute => {
        if (attribute.name !== 'hidden') shell.removeAttribute(attribute.name);
      });
      Array.from(fullCard.attributes).forEach(attribute => {
        shell.setAttribute(attribute.name, attribute.value);
      });

      shell.innerHTML = fullCard.innerHTML;
      shell.hidden = wasHidden;
      shell.removeAttribute('aria-busy');
      shellByProductId.delete(productId);
    };

    const pendingPages = [];
    for (let page = 2; page <= totalPages; page += 1) pendingPages.push(page);

    let cursor = 0;
    const worker = async () => {
      while (cursor < pendingPages.length) {
        const page = pendingPages[cursor];
        cursor += 1;
        const pageCards = await fetchPublisherBatch(page);
        pageCards.forEach(hydrateShell);
      }
    };

    const workerCount = Math.min(2, pendingPages.length);
    await Promise.all(Array.from({ length: workerCount }, () => worker()));

    shellByProductId.forEach(shell => shell.removeAttribute('aria-busy'));
  };

  const setupSeriesBrowser = browser => {
    const container = browser.parentElement;
    const directory = browser.querySelector('[data-series-directory]');
    const nav = browser.querySelector('[data-series-nav]');
    const currentSeriesLabel = browser.querySelector('[data-series-current]');
    const seriesSelect = browser.querySelector('[data-series-select]');
    const categorySelect = browser.querySelector('[data-category-filter]');
    const availabilitySelect = browser.querySelector('[data-availability-filter]');
    const preorderCloseSelect = browser.querySelector('[data-preorder-close-filter]');
    const preorderCloseControl = browser.querySelector('[data-preorder-close-control]');
    const searchInput = browser.querySelector('[data-publisher-search]');
    const clearFiltersButton = browser.querySelector('[data-clear-publisher-filters]');
    const filterCount = browser.querySelector('[data-filter-count]');
    const source = container?.querySelector('[data-series-source]');
    const list = container?.querySelector('[data-series-list]');
    const empty = container?.querySelector('[data-filter-empty]');
    if (!nav || !source || !list) return;

    const cards = Array.from(source.children).filter(element => element.classList.contains('product-card'));
    if (!cards.length) return;

    /* GAMECART PUBLISHER PERFORMANCE PHASE 3 2026 10 01 */
    source.remove();

    const seriesMap = new Map();
    const categoryMap = new Map();
    const availabilityMap = new Map();
    const preorderCloseMap = new Map();
    const cardMeta = new Map();

    const normalizePreorderClose = raw => {
      const value = String(raw || '').trim();
      const match = value.match(/^(\d{4}-\d{2}-\d{2})/);
      return match ? match[1] : value;
    };

    const formatPreorderClose = value => {
      const match = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (!match) return value;

      const date = new Date(Date.UTC(
        Number.parseInt(match[1], 10),
        Number.parseInt(match[2], 10) - 1,
        Number.parseInt(match[3], 10)
      ));

      return new Intl.DateTimeFormat(undefined, {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
        timeZone: 'UTC'
      }).format(date);
    };

    cards.forEach(card => {
      const display = seriesForCard(card);
      const key = display.toLocaleLowerCase();
      const category = (card.dataset.category || '').trim() || 'Other';
      const availability = (card.dataset.availability || '').trim() || 'in-stock';
      const preorderClose = normalizePreorderClose(card.dataset.preorderClose);
      const searchText = [
        card.dataset.productTitle || '',
        display,
        category
      ].join(' ').toLocaleLowerCase();
      const issue = issueValue(card);
      const issueNumber = parseFloat(issue);
      const issueNumeric = Number.isFinite(issueNumber);

      cardMeta.set(card, {
        display,
        key,
        category,
        availability,
        preorderClose,
        searchText,
        issue,
        issueNumber,
        issueNumeric
      });

      if (!seriesMap.has(key)) {
        seriesMap.set(key, { key, display, cards: [], id: seriesSlug(key), link: null, option: null });
      }

      const entry = seriesMap.get(key);
      entry.cards.push(card);

      if (entry.display === entry.display.toUpperCase() && display !== display.toUpperCase()) {
        entry.display = display;
      }

      categoryMap.set(category, (categoryMap.get(category) || 0) + 1);
      availabilityMap.set(availability, (availabilityMap.get(availability) || 0) + 1);
      if (availability === 'preorder' && preorderClose) {
        preorderCloseMap.set(preorderClose, (preorderCloseMap.get(preorderClose) || 0) + 1);
      }
    });

    const entries = Array.from(seriesMap.values())
      .sort((a, b) => collator.compare(a.display, b.display));

    if (categorySelect) {
      Array.from(categoryMap.keys())
        .sort((a, b) => collator.compare(a, b))
        .forEach(category => {
          const option = document.createElement('option');
          option.value = category;
          option.textContent = category + ' (' + categoryMap.get(category) + ')';
          categorySelect.appendChild(option);
        });

      const control = categorySelect.closest('[data-filter-control]');
      if (control && categoryMap.size < 2) control.hidden = true;
    }

    if (availabilitySelect) {
      availabilityOrder
        .filter(value => availabilityMap.has(value))
        .forEach(value => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = (availabilityLabels[value] || value) + ' (' + availabilityMap.get(value) + ')';
          availabilitySelect.appendChild(option);
        });

      const control = availabilitySelect.closest('[data-filter-control]');
      if (control && availabilityMap.size < 2) control.hidden = true;
    }

    if (preorderCloseSelect) {
      Array.from(preorderCloseMap.keys())
        .sort((a, b) => a.localeCompare(b))
        .forEach(value => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = formatPreorderClose(value) + ' (' + preorderCloseMap.get(value) + ')';
          preorderCloseSelect.appendChild(option);
        });

      if (preorderCloseControl) preorderCloseControl.hidden = preorderCloseMap.size === 0;
    }

    const navFragment = document.createDocumentFragment();
    const listFragment = document.createDocumentFragment();
    const selectFragment = seriesSelect ? document.createDocumentFragment() : null;
    const groupRecords = [];
    const seriesLinks = [];

    const allLink = document.createElement('a');
    allLink.className = 'series-directory__all is-active';
    allLink.href = '#all-series';
    allLink.dataset.seriesFilter = 'all';
    allLink.setAttribute('aria-current', 'true');

    const allLabel = document.createElement('span');
    allLabel.textContent = 'All Series';
    const allCount = document.createElement('small');
    allCount.textContent = String(cards.length);
    allLink.append(allLabel, allCount);
    navFragment.appendChild(allLink);
    seriesLinks.push(allLink);

    const letterGroups = new Map();

    entries.forEach(entry => {
      const initial = seriesInitial(entry.display);
      let group = letterGroups.get(initial);

      if (!group) {
        const section = document.createElement('section');
        section.className = 'series-directory__group';
        section.dataset.seriesLetter = initial;

        const heading = document.createElement('h3');
        heading.textContent = initial;

        const linkContainer = document.createElement('div');
        linkContainer.className = 'series-directory__links';

        section.append(heading, linkContainer);
        navFragment.appendChild(section);
        group = { section, linkContainer, links: [] };
        letterGroups.set(initial, group);
      }

      const link = document.createElement('a');
      link.className = 'series-directory__item';
      link.href = '#series-' + entry.id;
      link.dataset.seriesFilter = entry.id;
      link.dataset.seriesSort = entry.key;

      const label = document.createElement('span');
      label.textContent = entry.display;

      const count = document.createElement('small');
      count.textContent = String(entry.cards.length);

      link.append(label, count);
      group.linkContainer.appendChild(link);
      group.links.push(link);
      seriesLinks.push(link);
      entry.link = link;
      entry.linkCount = count;

      if (seriesSelect && selectFragment) {
        const option = document.createElement('option');
        option.value = entry.id;
        option.textContent = entry.display + ' (' + entry.cards.length + ')';
        option.dataset.seriesCountLabel = entry.display;
        selectFragment.appendChild(option);
        entry.option = option;
      }

      const seriesGroup = document.createElement('section');
      seriesGroup.className = 'publisher-series-group';
      seriesGroup.id = 'series-' + entry.id;
      seriesGroup.dataset.seriesGroup = entry.id;
      seriesGroup.dataset.seriesSort = entry.key;

      const heading = document.createElement('div');
      heading.className = 'publisher-series-heading';

      const headingLeft = document.createElement('div');
      const eyebrow = document.createElement('span');
      eyebrow.className = 'eyebrow';
      eyebrow.textContent = 'Series';

      const title = document.createElement('h2');
      title.textContent = entry.display;

      headingLeft.append(eyebrow, title);

      const countLabel = document.createElement('span');
      countLabel.dataset.seriesVisibleCount = '';
      countLabel.textContent = entry.cards.length === 1 ? '1 listing' : String(entry.cards.length) + ' listings';

      heading.append(headingLeft, countLabel);

      const issueBuild = buildIssueGroups(entry.cards, cardMeta);
      seriesGroup.append(heading, issueBuild.element);
      listFragment.appendChild(seriesGroup);

      entry.groupElement = seriesGroup;
      groupRecords.push({
        element: seriesGroup,
        cards: entry.cards,
        issues: issueBuild.records,
        countLabel
      });
    });

    nav.appendChild(navFragment);
    if (seriesSelect && selectFragment) seriesSelect.appendChild(selectFragment);
    list.appendChild(listFragment);

    const entryById = new Map(entries.map(entry => [entry.id, entry]));
    const letterGroupRecords = Array.from(letterGroups.values()).map(group => ({
      section: group.section,
      links: group.links
    }));
    let activeSeries = 'all';

    const baseFilterMatch = card => {
      const categoryValue = categorySelect?.value || 'all';
      const availabilityValue = availabilitySelect?.value || 'all';
      const preorderCloseValue = preorderCloseSelect?.value || 'all';
      const searchValue = (searchInput?.value || '').trim().toLocaleLowerCase();
      const meta = cardMeta.get(card);

      if (!meta) return true;
      if (categoryValue !== 'all' && meta.category !== categoryValue) return false;
      if (availabilityValue !== 'all' && meta.availability !== availabilityValue) return false;
      if (preorderCloseValue !== 'all' && meta.preorderClose !== preorderCloseValue) return false;
      if (searchValue && !meta.searchText.includes(searchValue)) return false;

      return true;
    };

    const matchingCountForEntry = entry => entry.cards.reduce((count, card) => count + (baseFilterMatch(card) ? 1 : 0), 0);

    const syncSeriesControls = () => {
      const allMatching = cards.reduce((count, card) => count + (baseFilterMatch(card) ? 1 : 0), 0);
      allCount.textContent = String(allMatching);

      entries.forEach(entry => {
        const count = matchingCountForEntry(entry);
        const countEl = entry.linkCount;
        if (countEl) countEl.textContent = String(count);
        if (entry.link) entry.link.hidden = count === 0;
        if (entry.option) {
          entry.option.disabled = count === 0;
          entry.option.textContent = entry.display + ' (' + count + ')';
        }
      });

      letterGroupRecords.forEach(group => {
        const visibleLinks = group.links.some(link => !link.hidden);
        group.section.hidden = !visibleLinks;
      });

      if (activeSeries !== 'all') {
        const entry = entryById.get(activeSeries);
        if (!entry || matchingCountForEntry(entry) === 0) activeSeries = 'all';
      }

      seriesLinks.forEach(link => {
        const active = link.dataset.seriesFilter === activeSeries;
        link.classList.toggle('is-active', active);
        if (active) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });

      if (seriesSelect) seriesSelect.value = activeSeries;

      if (currentSeriesLabel) {
        if (activeSeries === 'all') {
          currentSeriesLabel.textContent = 'All Series (' + allMatching + ')';
        } else {
          const entry = entryById.get(activeSeries);
          const count = entry ? matchingCountForEntry(entry) : 0;
          currentSeriesLabel.textContent = entry ? entry.display + ' (' + count + ')' : 'All Series (' + allMatching + ')';
        }
      }
    };

    const applyView = () => {
      syncSeriesControls();
      let visibleTotal = 0;

      groupRecords.forEach(record => {
        const group = record.element;
        const groupSelected = activeSeries === 'all' || group.dataset.seriesGroup === activeSeries;
        let groupVisible = 0;

        record.cards.forEach(card => {
          const show = groupSelected && baseFilterMatch(card);
          card.hidden = !show;
          if (show) groupVisible += 1;
        });

        record.issues.forEach(issue => {
          let visibleCards = 0;
          issue.cards.forEach(card => {
            if (!card.hidden) visibleCards += 1;
          });
          issue.element.hidden = visibleCards === 0;
          if (issue.countLabel) issue.countLabel.textContent = visibleCards === 1 ? '1 cover' : String(visibleCards) + ' covers';
        });

        if (record.countLabel) record.countLabel.textContent = groupVisible === 1 ? '1 listing' : String(groupVisible) + ' listings';

        group.hidden = !groupSelected || groupVisible === 0;
        visibleTotal += groupVisible;
      });

      if (filterCount) filterCount.textContent = visibleTotal === 1 ? '1 title shown' : String(visibleTotal) + ' titles shown';
      if (empty) empty.hidden = visibleTotal !== 0;

      const filtersActive =
        (categorySelect?.value || 'all') !== 'all' ||
        (availabilitySelect?.value || 'all') !== 'all' ||
        (preorderCloseSelect?.value || 'all') !== 'all' ||
        Boolean((searchInput?.value || '').trim());

      if (clearFiltersButton) clearFiltersButton.disabled = !filtersActive;
    };

    const chooseSeries = (value, scrollToSeries) => {
      activeSeries = value || 'all';
      applyView();

      if (activeSeries === 'all') {
        history.replaceState(null, '', window.location.pathname + window.location.search);
        if (scrollToSeries) browser.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        history.replaceState(null, '', '#series-' + activeSeries);
        if (scrollToSeries) {
          const target = entryById.get(activeSeries)?.groupElement;
          target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }

      if (directory?.open) directory.removeAttribute('open');
    };

    seriesLinks.forEach(link => {
      link.addEventListener('click', event => {
        event.preventDefault();
        chooseSeries(link.dataset.seriesFilter || 'all', true);
      });
    });

    seriesSelect?.addEventListener('change', () => {
      chooseSeries(seriesSelect.value || 'all', true);
    });

    categorySelect?.addEventListener('change', applyView);
    availabilitySelect?.addEventListener('change', applyView);
    preorderCloseSelect?.addEventListener('change', applyView);

    let searchDebounce = 0;
    searchInput?.addEventListener('input', () => {
      window.clearTimeout(searchDebounce);
      searchDebounce = window.setTimeout(applyView, 140);
    });

    clearFiltersButton?.addEventListener('click', () => {
      window.clearTimeout(searchDebounce);
      if (categorySelect) categorySelect.value = 'all';
      if (availabilitySelect) availabilitySelect.value = 'all';
      if (preorderCloseSelect) preorderCloseSelect.value = 'all';
      if (searchInput) searchInput.value = '';
      applyView();
      searchInput?.focus();
    });

    const hash = window.location.hash.replace('#series-', '');
    if (hash && entryById.has(hash)) activeSeries = hash;

    applyView();

    hydratePublisherCards(browser, cards).catch(error => {
      console.warn('Game Cart publisher card hydration:', error);
      cards
        .filter(card => card.classList.contains('publisher-card-shell'))
        .forEach(shell => shell.removeAttribute('aria-busy'));
    });
  };


  



  const bootSeriesBrowser = browser => {
    const totalProducts = Number.parseInt(browser.dataset.totalProducts || '0', 10);
    const totalPages = Number.parseInt(browser.dataset.seriesTotalPages || '1', 10);
    const source = browser.parentElement?.querySelector('[data-series-source]');

    if (!source || !Number.isFinite(totalProducts) || totalProducts <= 250 || !Number.isFinite(totalPages) || totalPages <= 1) {
      setupSeriesBrowser(browser);
      return;
    }

    source.hidden = true;
    const pages = Array.from({ length: totalPages }, (_, index) => index + 1);
    const pageResults = new Array(totalPages);
    let cursor = 0;

    const worker = async () => {
      while (cursor < pages.length) {
        const page = pages[cursor];
        cursor += 1;
        pageResults[page - 1] = await fetchPublisherBatch(page);
      }
    };

    const workerCount = Math.min(2, pages.length);
    Promise.all(Array.from({ length: workerCount }, () => worker()))
      .then(() => {
        const completeCards = pageResults.flat().filter(Boolean);
        source.replaceChildren(...completeCards);
        source.hidden = false;
        browser.dataset.seriesTotalPages = '1';
        setupSeriesBrowser(browser);
      })
      .catch(error => {
        source.hidden = false;
        console.warn('Game Cart complete publisher load:', error);
        setupSeriesBrowser(browser);
      });
  };

  document.querySelectorAll('[data-series-browser]').forEach(bootSeriesBrowser);
})();
/* GAMECART MOBILE PUBLISHER FILTER COLLAPSE 2026 10 01 */
(() => {
  const mobilePublisherFilters = window.matchMedia('(max-width: 760px)');

  document.querySelectorAll('[data-publisher-filters]').forEach(filterBar => {
    const toggle = filterBar.querySelector('[data-publisher-filter-toggle]');
    const panel = filterBar.querySelector('[data-publisher-filter-panel]');
    if (!toggle || !panel) return;

    const setExpanded = expanded => {
      filterBar.classList.toggle('is-open', expanded);
      toggle.setAttribute('aria-expanded', String(expanded));
      if (mobilePublisherFilters.matches) {
        panel.setAttribute('aria-hidden', String(!expanded));
      } else {
        panel.removeAttribute('aria-hidden');
      }
    };

    setExpanded(!mobilePublisherFilters.matches);

    toggle.addEventListener('click', () => {
      if (!mobilePublisherFilters.matches) return;
      setExpanded(toggle.getAttribute('aria-expanded') !== 'true');
    });

    const syncBreakpoint = event => setExpanded(!event.matches);
    if (mobilePublisherFilters.addEventListener) {
      mobilePublisherFilters.addEventListener('change', syncBreakpoint);
    } else if (mobilePublisherFilters.addListener) {
      mobilePublisherFilters.addListener(syncBreakpoint);
    }
  });
})();
/* GAMECART PUBLISHER TILE EXTENDED RESOLVER 2026 10 05 */
(() => {
  const tiles = Array.from(document.querySelectorAll('[data-publisher-preferences][data-publisher-collection-url]'))
    .filter(tile => {
      const total = Number.parseInt(tile.dataset.publisherProductsCount || '0', 10);
      const rank = Number.parseInt(tile.dataset.publisherCoverRank || '999', 10);
      const quality = tile.dataset.publisherCoverQuality || 'fallback';
      return total > 50 && tile.dataset.publisherCoverSource !== 'collection' && (rank > 1 || quality !== 'normal');
    });
  if (!tiles.length) return;

  const slug = value => String(value || '')
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  const specialty = value => / variant|foil|blank sketch|connecting|foc reveal|incentive|ratio variant|direct market exclusive|dm only/i.test(String(value || ''));

  const widthUrl = (value, width) => {
    try {
      const url = new URL(value, window.location.origin);
      url.searchParams.set('width', String(width));
      return url.toString();
    } catch (_) {
      return value;
    }
  };

  const parseBatch = html => {
    const template = document.createElement('template');
    template.innerHTML = String(html || '').trim();
    const batch = template.content.querySelector('[data-series-batch]');
    return batch ? Array.from(batch.children).filter(element => element.classList.contains('product-card')) : [];
  };

  const resolveTile = async tile => {
    const total = Number.parseInt(tile.dataset.publisherProductsCount || '0', 10);
    const totalPages = Math.ceil(total / 48);
    const preferences = String(tile.dataset.publisherPreferences || '').split('|').map(slug).filter(Boolean);
    if (totalPages <= 1 || !preferences.length) return;

    const currentRank = Number.parseInt(tile.dataset.publisherCoverRank || '999', 10);
    const currentQuality = tile.dataset.publisherCoverQuality || 'fallback';
    let bestRank = currentRank;
    let bestNormal = null;
    let bestSpecialty = null;

    for (let page = 2; page <= totalPages; page += 1) {
      const url = new URL(tile.dataset.publisherCollectionUrl, window.location.origin);
      url.searchParams.set('view', 'publisher-batch');
      url.searchParams.set('page', String(page));

      const response = await fetch(url.toString(), { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) return;

      const cards = parseBatch(await response.text());
      cards.forEach(card => {
        if (card.dataset.coverEligible !== 'true') return;
        const series = slug(card.dataset.series || '');
        const title = slug(card.dataset.productTitle || '');
        let rank = -1;

        for (let index = 0; index < preferences.length; index += 1) {
          const preference = preferences[index];
          if (series === preference || series.includes(preference) || title.includes(preference)) {
            rank = index;
            break;
          }
        }
        if (rank < 0 || rank > bestRank) return;

        if (rank < bestRank) {
          bestRank = rank;
          bestNormal = null;
          bestSpecialty = null;
        }

        const image = card.querySelector('.product-card__image');
        if (!image) return;
        if (specialty(card.dataset.productTitle)) {
          if (!bestSpecialty) bestSpecialty = image;
        } else if (!bestNormal) {
          bestNormal = image;
        }
      });

      if (bestRank === 0 && bestNormal) break;
    }

    let selected = null;
    if (bestRank < currentRank) selected = bestNormal || bestSpecialty;
    else if (bestRank === currentRank && currentQuality !== 'normal') selected = bestNormal;
    const target = tile.querySelector('.publisher-card__image img');
    if (!selected || !target) return;
    const source = selected.currentSrc || selected.src;
    if (!source) return;

    target.src = widthUrl(source, 800);
    target.srcset = [320, 480, 640, 800].map(width => widthUrl(source, width) + ' ' + width + 'w').join(', ');
    target.sizes = '(max-width: 800px) 50vw, 520px';
    tile.dataset.publisherCoverSource = 'preferred-extended';
    tile.dataset.publisherCoverRank = String(bestRank);
    tile.dataset.publisherCoverQuality = bestNormal ? 'normal' : 'specialty';
  };

  (async () => {
    for (const tile of tiles) {
      try { await resolveTile(tile); } catch (_) {}
    }
  })();
})();
